import { useEffect, useRef } from 'react';
import { useFullscreen } from './useFullscreen';

/**
 * Hook that aggressively maintains fullscreen mode, especially when keyboard opens
 */
export const usePersistentFullscreen = () => {
  const { requestFullscreen } = useFullscreen();
  const intervalRef = useRef(null);
  const isActiveRef = useRef(false);

  const startPersistentMode = () => {
    isActiveRef.current = true;
    
    // Clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    // Aggressive fullscreen maintenance every 200ms
    intervalRef.current = setInterval(() => {
      if (isActiveRef.current && 
          !document.fullscreenElement && 
          !document.webkitFullscreenElement && 
          !document.mozFullScreenElement && 
          !document.msFullscreenElement) {
        requestFullscreen();
      }
    }, 200);
  };

  const stopPersistentMode = () => {
    isActiveRef.current = false;
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // Force fullscreen immediately
  const forceFullscreen = () => {
    requestFullscreen();
    // Multiple attempts with different timings
    setTimeout(() => requestFullscreen(), 50);
    setTimeout(() => requestFullscreen(), 100);
    setTimeout(() => requestFullscreen(), 200);
    setTimeout(() => requestFullscreen(), 500);
  };

  useEffect(() => {
    return () => {
      stopPersistentMode();
    };
  }, []);

  return {
    startPersistentMode,
    stopPersistentMode,
    forceFullscreen
  };
};
